<template>
  <div class="crud_module--get_by_list">
    <div class="text" v-if="action == 'List'">
        {{name}}
    </div>
  </div>
</template>

<script>

export default {
  props: ["data","k","field","action"],
  async created() {
    
    if(this.field.parm != undefined){
      var list = [];
      eval("list = this.data."+this.field.parm.list+";")
      for(var i in list){
        var data = list[i];
        if(data[this.field.parm.key] == this.data[this.field.parm.key]){
          this.name = data[this.field.parm.display_key];
        }
      }
    }
  },
  methods: {
  },
  computed:{
  },
  data() {
    return {
      name:"",
      list:[]
    }
  }
}
</script>

<style lang="scss">
.crud_module--get_by_list{
  width: 100%;
}
</style>